import styled from 'styled-components';
import Icon from '@omilia/icon';

export const SOriginalUtternaceContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const SIcon = styled(Icon)`
  margin-right: 10px;
`;
